import * as actionTypes from "../action-types";

//! Auth
export const toggleLoginModal = payload => ({ type: actionTypes.TOGGLE_LOGIN_MODAL, payload });
export const toggleSignupModal = payload => ({ type: actionTypes.TOGGLE_SIGNUP_MODAL, payload });
export const toggleForgetPasswordModal = payload => ({ type: actionTypes.TOGGLE_FORGET_PASSWORD_MODAL, payload });

export const sendLoginOtp = payload => ({ type: actionTypes.SEND_LOGIN_OTP, payload });
export const customerLogin = payload => ({ type: actionTypes.CUSTOMER_LOGIN, payload });
export const customerSignup = payload => ({ type: actionTypes.CUSTOMER_SIGNUP, payload });
export const customerLogout = payload => ({ type: actionTypes.CUSTOMER_LOGOUT, payload });

//* Customer Detail
export const updateCustomerDetails = payload => ({ type: actionTypes.UPDATE_CUSTOMER_DETAILS, payload });

export const getCustomerDetails = payload => ({ type: actionTypes.GET_CUSTOMER_DETAILS, payload });
export const setCustomerDetails = payload => ({ type: actionTypes.SET_CUSTOMER_DETAILS, payload });

export const getMilanSathiCustomerDetails = payload => ({ type: actionTypes.GET_MILAN_SATHI_CUSTOMER_DETAILS, payload });
export const setMilanSathiCustomerDetails = payload => ({ type: actionTypes.SET_MILAN_SATHI_CUSTOMER_DETAILS, payload });